import React from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

interface ProductSoldOutModalProperties {
    readonly modalIsOpen: boolean;
    readonly closeModal: () => void;
    readonly onAfterClose: () => void;
}

export default function ProductSoldOutModal({
    modalIsOpen,
    closeModal,
    onAfterClose,
}: ProductSoldOutModalProperties): React.JSX.Element {
    const { t } = useTranslation("basket");

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className="modal-dialog cart-modal-info modal-width-fix"
            overlayClassName="react-modal-backdrop modal-transition"
            closeTimeoutMS={150}
            onAfterClose={(): void => onAfterClose()}
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className="well well-transparent product-sold">
                            <div className="seller-error">
                                &#x26D4; {t("oops")}
                            </div>
                            <p>{t("soldOutMessage")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
